"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _dateFns = require("date-fns");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // @1.30.1
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var LicensingForm = function LicensingForm(props) {
  var validLicenseStatus = ['none', 'active', 'expired'];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var closeModal = props.closeModal,
    availableLicenseList = props.availableLicenseList,
    row = props.row,
    settings = props.settings;
  var licenseStatus = row.licenseStatus,
    ownedLicenseList = row.ownedLicenseList;
  if (!validLicenseStatus.includes(licenseStatus)) {
    console.error("licenseStatus field returned an invalid value for product");
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Error:"), /*#__PURE__*/_react["default"].createElement("p", null, "Invalid license status. Please contact 3C Institute for support at", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      href: "mailto:support@3cisd.com"
    }, "support@3cisd.com"), "or by phone at (984) 316-0406."));
  }

  // inherits license from the ancestor group with the most depth
  var _useState3 = (0, _react.useState)(availableLicenseList.length > 0 && availableLicenseList.reduce(function (max, curr) {
      return curr.group.depth > max.group.depth ? curr : max;
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    heldLicense = _useState4[0],
    setHeldLicense = _useState4[1];
  var currentLicense = ownedLicenseList.length > 0 && ownedLicenseList.reduce(function (max, curr) {
    return curr.expiresAt > max.expiresAt ? curr : max;
  });
  function handleSubmit() {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (availableLicenseList.length) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            (0, _cccisdConfirm["default"])({
              message: 'Are you sure?',
              description: /*#__PURE__*/_react["default"].createElement("span", null, "This will use a license from ", /*#__PURE__*/_react["default"].createElement("b", null, heldLicense.group.group.label), ". This cannot be undone."),
              confirmLabel: 'Submit',
              abortLabel: 'Cancel'
            }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var response;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    setIsSubmitting(true);
                    if (!(licenseStatus === 'none')) {
                      _context.next = 7;
                      break;
                    }
                    _context.next = 4;
                    return _cccisdAxios["default"].post(Boilerplate.route('licensing.api.license.create'), {
                      groupId: heldLicense.groupId,
                      pawnId: row['pawn.pawnId'],
                      productId: settings.productId
                    });
                  case 4:
                    response = _context.sent;
                    _context.next = 10;
                    break;
                  case 7:
                    _context.next = 9;
                    return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.license.updateOwned', {
                      license: currentLicense.licenseId
                    }), {
                      action: 'renew',
                      heldLicenseId: heldLicense.licenseId
                    });
                  case 9:
                    response = _context.sent;
                  case 10:
                    if (response.data.status === 'error') {
                      (0, _cccisdNotification["default"])({
                        message: 'Failed to update license',
                        data: response.data.errors,
                        duration: 0,
                        type: 'danger'
                      });
                    }
                    setIsSubmitting(false);
                    if (response.data.status === 'success') {
                      closeModal();
                    }
                  case 13:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))).fail(function () {
              closeModal();
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  function handleAdminSubmit(_x) {
    return _handleAdminSubmit.apply(this, arguments);
  }
  function _handleAdminSubmit() {
    _handleAdminSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values) {
      var action, expireDate, currentLicenseId, deleteResponse, createResponse, updateResponse;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            action = values.action, expireDate = values.expireDate;
            if (!(!action || ['create', 'update'].includes(action) && !expireDate)) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            setIsSubmitting(true);
            currentLicenseId = currentLicense && currentLicense.licenseId;
            if (!(action === 'delete')) {
              _context3.next = 14;
              break;
            }
            _context3.next = 8;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('licensing.api.license.deleteOwned', {
              license: currentLicenseId
            }));
          case 8:
            deleteResponse = _context3.sent;
            if (deleteResponse.data.status === 'error') {
              (0, _cccisdNotification["default"])({
                message: 'Failed to delete license',
                data: (0, _get2["default"])(deleteResponse, 'data.errors', 'Could not delete license'),
                duration: 0,
                type: 'danger'
              });
            }
            if (deleteResponse.data.status === 'success') {
              (0, _cccisdNotification["default"])({
                message: 'License deleted successfully!',
                type: 'success'
              });
            }
            setIsSubmitting(false);
            closeModal();
            return _context3.abrupt("return");
          case 14:
            if (!(action === 'create')) {
              _context3.next = 27;
              break;
            }
            _context3.next = 17;
            return _cccisdAxios["default"].post(Boilerplate.route('licensing.api.license.create'), {
              groupId: heldLicense ? heldLicense.groupId : null,
              // better to have a groupId, but not necessary
              pawnId: row['pawn.pawnId'],
              productId: settings.productId,
              decrementHeld: false,
              expiration: (0, _dateFns.format)(expireDate, 'YYYY-MM-DD')
            });
          case 17:
            createResponse = _context3.sent;
            currentLicenseId = (0, _get2["default"])(createResponse, 'data.data.id', null);
            if (!(!currentLicenseId || createResponse.data.status === 'error')) {
              _context3.next = 23;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Failed to create license',
              data: (0, _get2["default"])(createResponse, 'data.errors', 'Could not get currentLicenseId'),
              duration: 0,
              type: 'danger'
            });
            setIsSubmitting(false);
            return _context3.abrupt("return");
          case 23:
            if (currentLicenseId && createResponse.data.status === 'success') {
              (0, _cccisdNotification["default"])({
                message: 'License created successfully!',
                type: 'success'
              });
            }
            setIsSubmitting(false);
            closeModal();
            return _context3.abrupt("return");
          case 27:
            if (!(action === 'update')) {
              _context3.next = 35;
              break;
            }
            _context3.next = 30;
            return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.license.updateOwned', {
              license: currentLicenseId
            }), _objectSpread({
              heldLicenseId: heldLicense && heldLicense.licenseId,
              expiration: (0, _dateFns.format)(expireDate, 'YYYY-MM-DD'),
              decrementHeld: false
            }, Date.parse(expireDate) < Date.now() ? {
              action: 'expire'
            } : {}));
          case 30:
            updateResponse = _context3.sent;
            if (updateResponse.data.status === 'error') {
              (0, _cccisdNotification["default"])({
                message: 'Failed to update license',
                data: updateResponse.data.errors,
                duration: 0,
                type: 'danger'
              });
            }
            if (updateResponse.data.status === 'success') {
              (0, _cccisdNotification["default"])({
                message: 'License updated successfully!',
                type: 'success'
              });
            }
            setIsSubmitting(false);
            if (updateResponse.data.status === 'success') {
              closeModal();
            }
          case 35:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _handleAdminSubmit.apply(this, arguments);
  }
  function renderHeadline() {
    var headline;
    switch (licenseStatus) {
      case 'none':
        {
          headline = /*#__PURE__*/_react["default"].createElement("span", null, "No license assigned");
          break;
        }
      case 'active':
        {
          var activeUntil = (0, _dateFns.parse)(currentLicense && currentLicense.expiresAt);
          var daysUntil = (0, _dateFns.differenceInDays)(activeUntil, new Date());
          headline = /*#__PURE__*/_react["default"].createElement("span", null, "License expires ", (0, _dateFns.format)(activeUntil, 'MM/DD/YYYY'), " (", daysUntil, " day", daysUntil === 1 ? '' : 's', ")");
          break;
        }
      case 'expired':
        {
          var expiredDate = (0, _dateFns.parse)(currentLicense && currentLicense.expiresAt);
          var daysAgo = (0, _dateFns.differenceInDays)(new Date(), expiredDate);
          headline = /*#__PURE__*/_react["default"].createElement("span", null, "License expired ", (0, _dateFns.format)(expiredDate, 'MM/DD/YYYY'), " (", daysAgo, " day", daysAgo === 1 ? '' : 's', ' ', "ago)");
          break;
        }
      default:
        console.error("licenseStatus field returned an invalid value for product");
        return null;
    }
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].headline
    }, headline);
  }
  function renderSubmitButton() {
    var buttonText;
    switch (licenseStatus) {
      case 'none':
        buttonText = 'Start License';
        break;
      case 'active':
        buttonText = 'Extend License';
        break;
      case 'expired':
        buttonText = 'Renew License';
        break;
      default:
        console.error("licenseStatus field returned an invalid value for product");
        return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      isLoading: isSubmitting,
      className: 'btn btn-primary ' + _style["default"].submitButton,
      title: buttonText,
      isDisabled: availableLicenseList.length === 0,
      type: "button",
      onClick: handleSubmit
    });
  }
  function renderAvailableLicenses() {
    if (availableLicenseList.length === 0) {
      return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, "No available licenses."));
    }
    var months = heldLicense.product.durationMonths;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].totalAvailable
    }, "Total available licenses:", ' ', /*#__PURE__*/_react["default"].createElement("b", null, availableLicenseList.reduce(function (total, curr) {
      return total + curr.quantity;
    }, 0))), availableLicenseList.length > 1 && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      initialValues: {
        group: heldLicense.groupId
      }
    }, function (_ref) {
      var setFieldValue = _ref.setFieldValue;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "group",
        component: _cccisdFormik.CccisdSelect,
        label: "Consume license from:",
        options: availableLicenseList.map(function (l) {
          return {
            value: l.groupId,
            label: "".concat(l.group.group.label, " (").concat(l.quantity, " available)")
          };
        }),
        onChange: function onChange(e) {
          setFieldValue('group', e.target.value);
          setHeldLicense(availableLicenseList.find(function (l) {
            return l.groupId === Number(e.target.value);
          }));
        }
      });
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].licenseExpireDetails
    }, "A license will be used from ", /*#__PURE__*/_react["default"].createElement("b", null, heldLicense.group.group.label), licenseStatus === 'active' ? ", and the user's access will be extended an additional ".concat(months, " months (").concat((0, _dateFns.format)((0, _dateFns.addMonths)((0, _dateFns.parse)(currentLicense.expiresAt), months), 'MM/DD/YYYY'), ")") : ". The license will start now and be available for ".concat(months, " months (").concat((0, _dateFns.format)((0, _dateFns.addMonths)(new Date(), months), 'MM/DD/YYYY'), ")"), ". This cannot be undone."));
  }
  function renderAdminArea() {
    var fields = licenseStatus === 'none' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      type: "radio",
      name: "action",
      value: "create"
    }), "\xA0\xA0Create new license and set expiration to\xA0"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expireDate"
    }, function (_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        selected: field.value,
        className: 'form-control input-sm ' + _style["default"].datePicker,
        placeholderText: "mm/dd/yyyy",
        onChange: function onChange(date) {
          return form.setFieldValue(field.name, date);
        }
      });
    })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      type: "radio",
      name: "action",
      value: "update"
    }), "\xA0\xA0Set expiration to\xA0"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expireDate"
    }, function (_ref3) {
      var field = _ref3.field,
        form = _ref3.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        selected: field.value,
        className: 'form-control input-sm ' + _style["default"].datePicker,
        placeholderText: "mm/dd/yyyy",
        onChange: function onChange(date) {
          return form.setFieldValue(field.name, date);
        }
      });
    }), currentLicense && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      type: "radio",
      name: "action",
      value: "delete"
    }), "\xA0\xA0Delete license", ' ', currentLicense.activatedDate ? 'activated on ' + (0, _dateFns.format)((0, _dateFns.parse)(currentLicense.activatedDate), 'MM/DD/YYYY') : '')));
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].adminArea
    }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
      title: "Admin"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      onSubmit: handleAdminSubmit,
      initialValues: {
        action: '',
        expireDate: (0, _dateFns.addMonths)(new Date(), 12)
      }
    }, function (_ref4) {
      var values = _ref4.values,
        onAdvancedSubmit = _ref4.handleSubmit;
      var action = values.action,
        expireDate = values.expireDate;
      var isDisabled = !action || ['create', 'renew'].includes(action) && !expireDate;
      var note = action === 'delete' ? 'This will not add a held license back to any group.' : 'This will not use a license from any group.';
      return /*#__PURE__*/_react["default"].createElement("form", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].formUpper
      }, fields), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: "Submit",
        className: "btn btn-primary",
        isLoading: isSubmitting,
        isDisabled: isDisabled,
        onClick: onAdvancedSubmit
      }), action && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].submitNote
      }, /*#__PURE__*/_react["default"].createElement("i", null, /*#__PURE__*/_react["default"].createElement("small", null, "Note: ", note))));
    })));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, renderHeadline(), renderAvailableLicenses(), Fortress.hasAccess('licensing.admin') && renderAdminArea(), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].btnContainer
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-default",
    type: "button",
    onClick: function onClick() {
      return closeModal();
    },
    disabled: isSubmitting
  }, "Cancel"), renderSubmitButton()));
};
var _default = exports["default"] = LicensingForm;